import React from 'react'
import './Home.css'

function Home() {
    return (
        <div className="home" id="section__home">
            <div className="home__box">
                <h1 className="home__boxName">Paulin <span>Alcoser</span></h1>
                <h1 className="home__boxRole">Web Developer.</h1>
            </div>
        </div>
    )
}
export default Home
